module.exports = __webpack_public_path__ + "73b17373b1db89e35e38373bb3863291.jpg";